import React from 'react';
import './blog-post.css';


//import reportWebVitals from './reportWebVitals';

const ComAppAnnounce = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Name Change Announcement</h2>
                    <p className="site-post-meta">August 7, 2022</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        Hi CSE!
                    </p>
                    <p>
                        We are writing to announce that ACM-W is being renamed to Women in Computing at the
                        University of Washington (WiC @ UW)! We want to thank you for all your input and
                        feedback! See you in the fall!
                    </p>
                    <p>
                        Best,<br></br>
                        WiC
                    </p>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default ComAppAnnounce;